import React, { Component, useContext } from "react";
import { useHistory } from "react-router-dom";
import "../Styles/SvgCommand.css";
import { store } from "../../../store.js";


const HomeIcon = (props) => {
  const history = useHistory();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const handleClick = () => {
    if (globalState.state.user) {
      dispatch({
        type: "INITIALIZE_FORM",
        payload: {formData: globalState.state.customFormData},
      });
      history.push('/customHome')
    } else
      history.push('/home')
     
  }
  return (
    <svg
      onClick = {handleClick}
      className = "clickStyle"
      baseProfile="tiny"
      id="Layer_1"
      version="1.2"
      width={"15.000000pt"} height={"15.000000pt"} viewBox="0 0 512.000000 512.000000">
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill={"gray"} stroke="none">
        <path d="M2515 4816 c-16 -8 -579 -518 -1250 -1134 -896 -823 -1226 -1132
          -1243 -1164 -28 -54 -28 -94 1 -148 26 -49 90 -90 139 -90 54 0 93 27 266 186
           96 87 178 161 183 162 5 2 9 -449 9 -1111 l0 -1114 23 -33 c12 -18 35 -43 50
          -54 28 -21 37 -21 684 -24 648 -2 656 -2 699 18 26 13 53 36 66 58 l23 37 3
          538 3 537 409 0 410 0 0 -528 c0 -527 0 -528 23 -572 14 -30 36 -53 62 -67
          l40 -23 649 0 c637 0 651 0 692 21 26 12 53 36 66 57 l23 37 3 1098 2 1098
          161 -150 c126 -118 169 -153 201 -162 77 -20 153 14 187 85 27 55 26 91 -1
          144 -30 56 -2411 2284 -2459 2301 -42 15 -87 13 -124 -3z m885 -1139 l815
          -763 3 -1147 2 -1147 -450 0 -450 0 0 528 c0 528 0 528 -22 572 -13 24 -36 53
          -51 64 -28 21 -38 21 -667 21 -629 0 -639 0 -666 -21 -15 -11 -37 -33 -48 -48
          -21 -27 -21 -40 -24 -572 l-2 -544 -450 0 -450 0 0 1158 0 1158 818 752 c449
          413 819 752 822 752 3 0 372 -343 820 -763z"/>

      </g>

    </svg>
  );
};

export default HomeIcon;
